<template>
  <div class="d-flex flex-column m-0">
    <span class="custom-route-error-color font-small" v-if="!isValid.state">{{ $t(isValid.message) }}</span>
    <span class="custom-route-error-color font-small" v-for="error in backendValidationErrors" :key="error">
      {{ $t(error) }}
    </span>
  </div>
  <div class="row">
    <div class="col-1 m-0"></div>
    <div
        class="col-11 m-0 position-relative input-col-10-padding"
        :data-bs-toggle="'modal'"
        :data-bs-target="'#picker-frequency'"
    >
      <input
          class="custom-select-frequency"
          id="picker-frequency-date"
          :placeholder="$t('select_frequency_of_journey')"
          :value="store.state.orderTrueDriverDates.selectedPredefinedOption === selectPredefinedOptionsConstants.USER_DEFINED ?
          this.store.state.orderTrueDriverDates.translatedSelectedDateText : buildPredefinedSelectionString(store.state.orderTrueDriverDates.selectedPredefinedOption)"
      />
      <div class="arrow-select position-absolute icon-calender-position">
        <img src="/assets/images/calendar-calendar-1.svg" />
      </div>
    </div>
  </div>

  <ModalComponent
      :id-data="'picker-frequency'"
      :modal-title="$t('select_frequency_of_journey')"
  >
    <template #body-content>
      <div class="d-flex flex-column align-items-center">
        <div class="modal-calendar-container d-flex flex-row">
          <div id="date-picker-date-1">
            <DatepickerComponent
                monthNameFormat="long"
                id="picker-main"
                ref="datepickerMain"
                :locale="store.state.general.locale"
                :minDate="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)"
                inline
                auto-apply
                :multi-dates="true"
                highlightDisabledDays
                :enableTimePicker="false"
                :modelValue="selectedDates"
                @update:modelValue="selectDate($event)"
		@internalModelChange="internalModelChange($event)">
            </DatepickerComponent>
          </div>
        </div>
        <div class="d-flex display-days-container">
          <div>
            {{ $t('day_count_selected') }}
          </div>
          <div v-if="selectedDates">
            {{ this.selectedDates.length === 1 ? this.selectedDates.length : this.selectedDates.length - 1 }}
          </div>
          <div v-if="!selectedDates">
            0
          </div>
        </div>
        <div class="predefined-select-modal-container" id="predefined-select-modal">
          <div class="d-flex justify-content-center align-items-center h-100">
            <select
                :value="!isCustomOption ? store.state.orderTrueDriverDates.selectedPredefinedOption : selectPredefinedOptionsConstants.USER_DEFINED"
                @change="selectPredefinedOption($event)"
                class="select-predefine-container"
                :disabled="isDisabledSelect"
            >
              <option :value="selectPredefinedOptionsConstants.CHOOSE" disabled :selected="[]">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.CHOOSE) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.NOT_REPEAT">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.NOT_REPEAT) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.DAILY">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.DAILY) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.WEEKLY">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.WEEKLY) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.MONTHLY">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.MONTHLY) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.ANNUALLY">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.ANNUALLY) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.WEEKDAY">
                {{ buildPredefinedSelectionString(selectPredefinedOptionsConstants.WEEKDAY) }}
              </option>
              <option :value="selectPredefinedOptionsConstants.USER_DEFINED" v-if="isCustomOption">
                {{ this.store.state.orderTrueDriverDates.translatedSelectedDateText }}
              </option>
              <option :value="selectPredefinedOptionsConstants.CUSTOM">{{ $t('custom') }}</option>
            </select>
          </div>
        </div>

        <div class="select-end-date-picker-cotainer d-flex align-items-center mb-4" :style="{display: !isCustomOption ? 'block' : 'none!important'}">
          <div class="select-end-date-picker-cotainer__text">{{ $t('ends') }}</div>
          <DatepickerComponent
              monthNameFormat="long"
              auto-apply
              :closeOnAutoApply="true"
              :locale="store.state.general.locale"
              :multiDates="false"
              :minDate="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)"
              :enableTimePicker="false"
              v-model="endDate"
              id="picker-end-date-second"
              ref="datepicker-end-date-second"
          >
          </DatepickerComponent>
        </div>

        <ButtonComponent type="button" data-bs-target="#picker-frequency" data-bs-dismiss="modal" aria-label="Close"
            @click="submit" class="m-0"
            :class="{'calendar-select-disabled-button' : isDisabledSelect, 'calendar-select-submit-button' : !isDisabledSelect}"
            :disabled="isDisabledSelect">
          <template #btnContent>{{ $t('select') }}</template>
        </ButtonComponent>
      </div>
    </template>
  </ModalComponent>

  <Teleport to="body">
    <div class="position-fixed user-defined-select-modal" id="user-defined-select-modal">
      <div class="container">
        <div class="user-defined-select-modal__container d-flex flex-row align-items-center mt-5">
          <div class="user-defined-select-modal__container__define-text">
            {{ $t('repeat_every') }}
          </div>
          <div class="user-defined-select-modal__container__define-input">
            <input
                class="input-user-predefine-container"
                type="number"
                min="1"
                :value="store.state.orderTrueDriverDates.period"
                @change="event => store.dispatch('orderTrueDriverDates/updateState', [{prop: 'period', value: parseInt(event.target.value)}])">
          </div>
          <div class="user-defined-select-modal__container__define-select">
            <select
                v-model="store.state.orderTrueDriverDates.selectedPeriodType"
                @change="selectPeriodType($event)"
                class="select-default-container"
            >
              <option :value="selectDefaultPeriodTypeConstants.DAY" selected>
                {{ store.state.orderTrueDriverDates.period === 1 ? $t('day_1')  : $t('day_2')}}
              </option>
              <option :value="selectDefaultPeriodTypeConstants.WEEK">
                {{ store.state.orderTrueDriverDates.period === 1 ? $t('week_1')  : $t('week_2')}}
              </option>
              <option :value="selectDefaultPeriodTypeConstants.MONTH">
                {{ store.state.orderTrueDriverDates.period === 1 ? $t('month_1')  : $t('month_2')}}
              </option>
              <option :value="selectDefaultPeriodTypeConstants.YEAR">
                {{ store.state.orderTrueDriverDates.period === 1 ? $t('year_1')  : $t('year_2')}}
              </option>
            </select>
          </div>
        </div>

        <template v-if="store.state.orderTrueDriverDates.selectedPeriodType === selectDefaultPeriodTypeConstants.WEEK">
          <div class="select-week-day-wrapper">
            <div class="select-week-day-wrapper__text">{{ $t('repeat_on') }}</div>
            <div class="select-week-day-wrapper__items d-flex">
                <template v-for="day in weekDays" :key="day.id + 1">
                  <div class="select-week-day-wrapper__items__item d-flex align-items-center">
                    <label :for="day.name + day.id" class="select-week-day-wrapper__items__item__label">{{ $t(day.name)[0] }}</label>
                    <input
                        type="checkbox"
                        :id="day.name + day.id"
                        :value="day.id"
                        v-model="selectedDays"
                        :disabled="day.id === store.state.orderTrueDriverDates.selectedDays[0] && store.state.orderTrueDriverDates.selectedDays.length === 1"
                    />
                  </div>
                </template>
            </div>
          </div>
        </template>

        <div class="select-end-date-picker-cotainer">
          <div class="select-end-date-picker-cotainer__text">{{ $t('ends') }}</div>
          <DatepickerComponent
              monthNameFormat="long"
              auto-apply
              :closeOnAutoApply="true"
              :locale="store.state.general.locale"
              :multiDates="false"
              :minDate="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)"
              :enableTimePicker="false"
              v-model="endDate"
              id="picker-end-date"
              ref="datepicker-end-date"
          >
          </DatepickerComponent>
        </div>

        <div class="d-flex justify-content-end">
          <button
              class="select-user-defined-option-submit-button"
              type="submit"
              @click="calculateAllSelectedDates([store.state.orderTrueDriverDates.selectedStartDate], store.state.orderTrueDriverDates.selectedPeriodType)">
            {{$t('save')}}
          </button>
        </div>
        <button
            @click="$helpers.closeModal({
            id: 'user-defined-select-modal',
            backdrop: 'custom-modal-backdrop-1',
            bodyOverflow: 'body-overflow'
          }), selectDate([store.state.orderTrueDriverDates.selectedStartDate])"
            class="custom-button modal-close-button">
          <span><img src="/assets/images/xTimes-1.svg" alt="times"></span>
        </button>
      </div>
    </div>
  </Teleport>


</template>

<script lang="ts">
import './calendar.scss';
import {defineComponent} from "vue";
import DatepickerComponent from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
// @ts-ignore
import ButtonComponent from '../../components/Button/ButtonComponent.vue';
// @ts-ignore
import ModalComponent from '../../components/modal/ModalComponent.vue';
// @ts-ignore
import InputComponent from '../../components/input/InputComponent.vue';
import {useStore} from "vuex";
import {SelectDefaultPeriodType} from "../../interfaces/enums/SelectDefaultPeriodType.enum";
import {SelectPredefinedOptions} from "../../interfaces/enums/SelectPredefinedOptions.enum";
import {modalEvents} from "../../helpers/modalEvents";
import axios from 'axios';
import apiService from "../../services/apiService";
import {axiosHelpers} from "../../helpers/axiosHelpers";
import nameOfHelper from '../../helpers/nameOfHelper';
import {dateHelpers} from "../../helpers/dateHelpers";

export default defineComponent({
  name: 'CalendarComponent',
  components: {
    Option,
    InputComponent,
    ModalComponent,
    DatepickerComponent,
    ButtonComponent
  },
  props: {
    isValid: {
      type: Object
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      selectedDays: <number[]|null>null,
      selectedDates: <Date[] | string[] | null | any[]>null,
      endDate: <Date | null>null,
      selectPredefinedOptionsConstants: SelectPredefinedOptions,
      selectDefaultPeriodTypeConstants: SelectDefaultPeriodType,

      isDisabledSelect: true,
      isCustomOption: false,

      weekDays: <{id: number, name: string, date: Date}[]>[
        {
          id: 0,
          name: 'Sunday',
          date: <Date | null>null
        },
        {
          id: 1,
          name: 'Monday',
          date: <Date | null>null
        },
        {
          id: 2,
          name: 'Tuesday',
          date: <Date | null>null
        },
        {
          id: 3,
          name: 'Wednesday',
          date: <Date | null>null
        },
        {
          id: 4,
          name: 'Thursday',
          date: <Date | null>null
        },
        {
          id: 5,
          name: 'Friday',
          date: <Date | null>null
        },
        {
          id: 6,
          name: 'Saturday',
          date: <Date | null>null
        }
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      internalDates: <Date[]>[],
      backendValidationErrors: <string[]>[],
    }
  },
  watch: {
    selectedDays: {
      handler(newVal, oldVal) {
        this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'selectedDays', value: newVal}]);

        if (newVal) {
          this.isDisabledSelect = false;
        }
      }
    },
    endDate: {
      handler(newVal, oldVal) {
          this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'selectedEndDate', value: newVal}]);
          this.selectPredefinedOption({target: {value: this.store.state.orderTrueDriverDates.selectedPredefinedOption}}, newVal);
      },
    },
    '$store.state.orderTrueDriver.arrivalDate': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.selectDate([newVal]);
        }
      }
    },
  },

  methods: {
    internalModelChange(this:any, event: Array<Date>): void {
      if (event !== null) {
        this.internalDates = [...event]
      }
    },

    getSelectedFrequencyString(this:any, data) {
      axios.get(apiService.selectedFrequencyEndpoint(), {params: data}).then(response => {
        this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'translatedSelectedDateText', value: response.data.translated_text.translated_locale_text}]);
      }).catch(error => {
        this.backendValidationErrors = [...axiosHelpers.handleAxiosErrors(error, 'key_unprocessable_content')];
      });
    },

    submit(this:any): void {
      const nameOf = (c) => nameOfHelper.obj(c);

      const state = this.store.state.orderTrueDriverDates;
      const dataKeys = <string[]>[
        nameOf(() => state.firstSelectedDay),
        nameOf(() => state.nthSelectedDay),
        nameOf(() => state.period),
        nameOf(() => state.selectedDays),
        nameOf(() => state.selectedEndDate),
        nameOf(() => state.selectedPeriodType),
        nameOf(() => state.selectedPredefinedOption),
        nameOf(() => state.selectedStartDate),
      ];

      let data = {};

      dataKeys.map((key: string) => {
        data[key] = state[key];
      })

      this.getSelectedFrequencyString(data);
    },

    buildPredefinedSelectionString(this:any, predefinedOption: string): string {
      let predefinedString = '';

      switch(predefinedOption) {

        case this.selectPredefinedOptionsConstants.CHOOSE:
          predefinedString = this.$t('select_an_option');
          break;

        case this.selectPredefinedOptionsConstants.NOT_REPEAT:
          predefinedString = this.$t('does_not_repeat');
          break;

        case this.selectPredefinedOptionsConstants.DAILY:
          predefinedString = this.$t('daily');
          break;

        case this.selectPredefinedOptionsConstants.WEEKLY:

          let tmp = this.selectedDates ? this.$t('' + this.weekDays.filter(day => day.id === this.selectedDates![0].getDay())[0].name + '_s') : null;
          predefinedString = this.$t('weekly_on') + ' ' + tmp;
          break;

        case this.selectPredefinedOptionsConstants.MONTHLY:
          let tmp_1 = this.store.state.orderTrueDriverDates.nthSelectedDay + 1;
          let tmp_2 = this.$t('th');
          let tmp_3 = this.selectedDates ? this.$t('' + this.weekDays.filter(day => day.id === this.selectedDates![0].getDay())[0].name + '_when') : null;

          predefinedString = this.$t('monthly_on_the') + ' ' + tmp_1 + tmp_2 + ' ' + tmp_3;

          break;

        case this.selectPredefinedOptionsConstants.ANNUALLY:
          let tmp_4 = this.selectedDates ? this.$t('' + this.months[this.selectedDates[0].getMonth()] + '_whose') : null;
          let tmp_5 = this.selectedDates ? this.selectedDates[0].getDate() : null;

          predefinedString = this.$t('annually_on') + ' ' + tmp_4 + ' ' + tmp_5;
          break;

        case this.selectPredefinedOptionsConstants.WEEKDAY:
          predefinedString = this.$t('every_weekday_monday_friday');
          break;
      }

      return predefinedString;
    },

    selectDate(this: any, event: Array<Date>): void {

      let selectedDays: number[] = [];
      let dates: Array<Date> = [];

      this.isDisabledSelect = false;
      this.isCustomOption = false;

      if (event === null) {
        this.selectedDates = [...<[]>this.selectedDates];

      } else {
        if (event.length > 2) {
          if (event.length - this.internalDates.length === 1) {

            this.selectedDates = [event[event.length - 1]];

          } else {

            dates = this.internalDates.filter((date) => {
              return !event.includes(date);
            })
            this.selectedDates = [...dates];

          }

        } else {
          this.selectedDates = [event[event.length - 1]];
        }
      }

      selectedDays = this.selectedDates.map((date) => new Date(date).getDay());
      selectedDays = [...new Set(selectedDays)];
      this.selectedDays = selectedDays;
      this.endDate = this.selectedDates[0];

      // INIT WEEK DAYS WITH FIRST SELECTED DATES
      for (let i = 0; i < 7; i++) {
        for (const days of this.weekDays) {
          if (days.id === new Date(new Date(this.selectedDates[0].getTime() + i * dateHelpers.dayInMiliseconds).toDateString()).getDay()) {
            days.date = new Date(new Date(this.selectedDates[0].getTime() + i * dateHelpers.dayInMiliseconds).toDateString());
          }
        }
      }

      /**
       * CREATE STORE STATE OF DATES FREQUENCY WHEN SELECT START DATE FROM MAIN DATEPICKER
       * AND RESETS ALL PREVIOUS SELECTED OPTIONS
       */
      const dataArr = [
        {prop: 'selectedStartDate', value: this.selectedDates[0]},
        {prop: 'selectedEndDate', value: this.selectedDates[0]},
        {prop: 'selectedDays', value: selectedDays},
        {prop: 'firstSelectedDay', value: selectedDays[0]},
        {prop: 'nthSelectedDay', value: dateHelpers.calculateNthSelectedDay(this.selectedDates[0])}
      ];

      this.store.dispatch('orderTrueDriverDates/updateState', dataArr);
      this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'selectedPredefinedOption', value: SelectPredefinedOptions.NOT_REPEAT}]);
    },

    selectPredefinedOption(this:any, event: Event|{target: {value: string}}, customEndDate = null): void {

      let newDates: Array<Date | string> | null = null;
      let startDate: Date = new Date(this.selectedDates![0]);
      let endDate = null as Date | null;

      switch ((event.target! as HTMLInputElement).value) {

        case SelectPredefinedOptions.NOT_REPEAT:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 0, 0, 0) : customEndDate;
          newDates = [startDate];
          break;

        case SelectPredefinedOptions.DAILY:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 0, 1, 0) : customEndDate;
          newDates = dateHelpers.calculateDates(1, startDate, endDate, 1, SelectDefaultPeriodType.DAY);
          break;

        case SelectPredefinedOptions.WEEKLY:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 0, 3, 0) : customEndDate;
          newDates = dateHelpers.calculateDates(1, startDate, endDate, 7, SelectDefaultPeriodType.WEEK);
          break;

        case SelectPredefinedOptions.MONTHLY:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 1, 0, 0) : customEndDate;
          newDates = dateHelpers.calculateAllNthDays(
              startDate,
              endDate,
              this.store.state.orderTrueDriverDates.nthSelectedDay,
              this.store.state.orderTrueDriverDates.selectedDays[0]);
          break;

        case SelectPredefinedOptions.ANNUALLY:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 2, 0, 0) : customEndDate;
          newDates = dateHelpers.calculateDates(1, startDate, endDate, 0, SelectDefaultPeriodType.YEAR);
          break;

        case SelectPredefinedOptions.WEEKDAY:
          endDate = !customEndDate ? dateHelpers.calculateEndDate(startDate, 0, 1, 0) : customEndDate;
          newDates = dateHelpers.calculateDates(1, startDate, endDate, 1, SelectDefaultPeriodType.DAY)
              .filter(el => el.getDay() !== 0)
              .filter(el => el.getDay() !== 6);
          break;

        case SelectPredefinedOptions.CUSTOM:
          this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'selectedPeriodType', value: SelectDefaultPeriodType.WEEK}]);
          modalEvents.openModal(event,{ id: 'user-defined-select-modal' }, 'custom-modal-backdrop-1');
          break;

        default:
          break;
      }

      switch((event.target! as HTMLInputElement).value) {
        case SelectPredefinedOptions.NOT_REPEAT:
        case SelectPredefinedOptions.DAILY:
        case SelectPredefinedOptions.WEEKLY:
        case SelectPredefinedOptions.MONTHLY:
        case SelectPredefinedOptions.ANNUALLY:
        case SelectPredefinedOptions.WEEKDAY:
          this.isCustomOption = false;

          this.store.dispatch(
              'orderTrueDriverDates/updateState',
              [{prop: 'selectedPredefinedOption', value: (event.target! as HTMLInputElement).value}]
          );

          this.selectedDates = [...<[]>newDates];
          this.selectedDates!.push(this.store.state.orderTrueDriverDates.selectedStartDate);

          this.store.dispatch(
              'orderTrueDriverDates/updateState',
              [{prop: 'selectedEndDate', value: endDate}]
          );

          this.endDate = endDate;
          break;

        default:
          break;
      }
    },

    selectPeriodType(this:any, event: Event): void {
      let defaultEnd: Date | null = null;
      let startDate: Date = this.selectedDates![0];

      switch ((event.target! as HTMLInputElement).value) {
        case SelectDefaultPeriodType.DAY:

          defaultEnd = dateHelpers.calculateEndDate(startDate, 0, 1,0);

          break
        case SelectDefaultPeriodType.WEEK:

          defaultEnd = dateHelpers.calculateEndDate(startDate, 0, 3,-1);

          break
        case SelectDefaultPeriodType.MONTH:

          defaultEnd = dateHelpers.calculateEndDate(startDate, 1, 0,0);

          break
        case SelectDefaultPeriodType.YEAR:

          defaultEnd = dateHelpers.calculateEndDate(startDate, 2, 1, 0);

          break
        default:
          break
      }
      this.endDate = defaultEnd;
      this.store.dispatch('orderTrueDriverDates/updateState', [
        {prop: 'selectedEndDate', value: defaultEnd},
        {prop: 'selectedPeriodType', value: (event.target! as HTMLInputElement).value}
      ]);

      this.selectedDays = [this.store.state.orderTrueDriverDates.firstSelectedDay];
    },

    calculateAllSelectedDates(
        this:any,
        dates: Array<Date>,
        selectedPeriodType: string
    ): void {
      const multipleDays: Array<Date> = [];
      let selectedDatesTemp: Array<Date> = [];
      let multiplier = 0;

      switch (selectedPeriodType) {
        case SelectDefaultPeriodType.DAY:

          multiplier = 1
          selectedDatesTemp = dateHelpers.calculateAllDates(
              this.store.state.orderTrueDriverDates.period,
              dates,
              this.store.state.orderTrueDriverDates.selectedEndDate,
              multiplier,
              selectedPeriodType
          );

          break
        case SelectDefaultPeriodType.WEEK:

          multiplier = 7
          let multipleTemp: Array<Date> = dateHelpers.getDatesOfSelectedDays(this.store.state.orderTrueDriverDates.selectedDays, this.weekDays);
          multipleDays.push(...multipleTemp);
          selectedDatesTemp = dateHelpers.calculateAllDates(
              this.store.state.orderTrueDriverDates.period,
              multipleDays,
              this.store.state.orderTrueDriverDates.selectedEndDate,
              multiplier,
              selectedPeriodType
          );

          break
        case SelectDefaultPeriodType.MONTH:
        case SelectDefaultPeriodType.YEAR:

          selectedDatesTemp = dateHelpers.calculateAllDates(
              this.store.state.orderTrueDriverDates.period,
              dates,
              this.store.state.orderTrueDriverDates.selectedEndDate,
              multiplier,
              selectedPeriodType
          );

          break
        default:
          break
      }

      const selectedDatesTempResult = [
        ...new Set(selectedDatesTemp.map((el: Date): string => el.toISOString()))
      ]
      this.selectedDates = [
        ...selectedDatesTempResult.map((el) => new Date(el))
      ]

      this.selectedDates.push(this.store.state.orderTrueDriverDates.selectedStartDate);

      // SHOW USER DEFINED CUSTOM SELECTED DATES
      this.isCustomOption = true;

      this.store.dispatch(
          'orderTrueDriverDates/updateState',
          [{prop: 'selectedPredefinedOption', value: 'user_defined'}]);

      modalEvents.closeModal({id: 'user-defined-select-modal', backdrop: 'custom-modal-backdrop-1', bodyOverflow: 'body-overflow'});

      this.submit();
    },
  },

  mounted() {
    let modal = document.querySelector('#picker-frequency');
    let modaldialog = modal!.querySelector('.modal-dialog');
    let header = modal!.querySelector('.modal-header');
    header!.classList.add('d-flex');
    header!.classList.add('justify-content-center');
    header!.classList.add('modal-header-border');
    modaldialog!.classList.remove('modal-xl');

    if (this.store.state.general.locale === 'lt') {
      let a: any = null;
      a = this.weekDays.shift();
      this.weekDays.push(a);
    }

    if (this.store.state.orderTrueDriver.arrivalDate) {
      // Date is selected sao we can change it's frequency
      this.isDisabledSelect = false;

      const newDates = [this.store.state.orderTrueDriver.arrivalDate];
      this.selectDate(newDates);
      this.store.dispatch('orderTrueDriverDates/updateState', [{prop: 'selectedPredefinedOption', value: SelectPredefinedOptions.NOT_REPEAT}]);
    }
  }
})
</script>
